import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialFeedComponent } from './social-feed/social-feed.component';
import { TranslateModule } from '@ngx-translate/core';
import { GoToCpsPanelComponent } from './go-to-cps-panel/go-to-cps-panel.component';
import { PracticeResourcesPanelComponent } from './practice-resources-panel/practice-resources-panel.component';
import { EventsPanelComponent } from './events-panel/events-panel.component'; 
import { InsightsPanelComponent } from './insights-panel/insights-panel.component';
import { ContinuingEducationPanelComponent } from './continuing-education-panel/continuing-education-panel.component';
import { DrugShortagesPanelComponent } from './drug-shortages-panel/drug-shortages-panel.component';
import { ContactUsComponent } from './contact-us/contact-us.component';


@NgModule({
  declarations: [SocialFeedComponent, GoToCpsPanelComponent, EventsPanelComponent, InsightsPanelComponent, ContinuingEducationPanelComponent, PracticeResourcesPanelComponent, DrugShortagesPanelComponent, ContactUsComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    SocialFeedComponent,
    GoToCpsPanelComponent,
    PracticeResourcesPanelComponent,
    EventsPanelComponent,
    InsightsPanelComponent,
    ContinuingEducationPanelComponent,
    DrugShortagesPanelComponent,
    ContactUsComponent
  ]
})
export class HubComponentsModule { }
